// extracted by mini-css-extract-plugin
module.exports = {"sectionContent":"FaqsPage_sectionContent__ZZZJZ","title":"FaqsPage_title__1-u7N","list":"FaqsPage_list__315w5","sectionWhite":"FaqsPage_sectionWhite__15whx"};